/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { withTranslation } from 'react-i18next'
import styles from './Confirmation.module.scss'

const ContactInformation = ({ t, i18n }) => {
  return (
    <>
      <div className="row">
        <div className="col-xs-12 col-lg-10">
          <p>
            <strong>{t('receive_confirmation.contact_information')}</strong>
          </p>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-6 col-lg-4">
          <p className={styles['margin_botton']}> {t('contact_information.contact')}</p>
        </div>
        <div className="col-xs-6 col-lg-8">
          <p className={styles['margin_botton']}>
            {t('contact_information.registry_of_motor')}
            <br />
            {t('contact_information.service_nova_scotia')}
          </p>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-6 col-lg-4">
          <p className={styles['margin_botton']}>{t('contact_information.online')}</p>
        </div>
        <div className="col-xs-6 col-lg-8">
          <p className={styles['margin_botton']}>
            {t('contact_information.online_desc1')}{' '}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://beta.novascotia.ca/public-enquiries?_ga=2.241405185.282748237.1592489335-281669742.1592350931"
              hrefLang={i18n.language !== "en" ? "en" : undefined}
            >
              {t('contact_information.online_desc2')}
            </a>
          </p>
        </div>
        <div className="col-xs-6 col-lg-4">
          <p className={styles['margin_botton']}>{t('contact_information.telephone')}</p>
        </div>
        <div className="col-xs-6 col-lg-8">
          <p className={styles['margin_botton']}>{t('contact_information.telephone_no')} {t('shared.or')} {t('contact_information.tollfree_no')}</p>
        </div>
      </div>
      {/* <div className="row">
        <div className="col-xs-6 col-lg-4">
          <p className={styles['margin_botton']}>
            {t('contact_information.tollfree')}
            <br />
            {t('contact_information.in_nova_scotia')}
          </p>
        </div>
        <div className="col-xs-6 col-lg-8">
          <p className={styles['margin_botton']}>{t('contact_information.tollfree_no')}</p>
        </div>
      </div> */}
      <div className="row">
        <div className="col-xs-6 col-lg-4">
          <p className={styles['margin_botton']}> {t('contact_information.mailing_address')}</p>
        </div>
        <div className="col-xs-6 col-lg-8">
          <p className={styles['margin_botton']}>
            {t('contact_information.post_box')}
            <br />
            {t('contact_information.halifax_nova_scotia')}
          </p>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-6 col-lg-4">
          <p className={styles['margin_botton']}>{t('contact_information.email')}</p>
        </div>
        <div className="col-xs-6 col-lg-8">
          <p className={styles['margin_botton']}>{t('contact_information.email_address')}</p>
        </div>
      </div>
    </>
  )
}

export default withTranslation('common')(ContactInformation)
